import React, { useEffect } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import TextField from "@mui/material/TextField";
import { RightChevron } from "../../../common/js/icons";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { auto } from "@popperjs/core";

// Header of the comment section
const CommentHeader = styled('div')(() => ({
    paddingTop: "20px",
}));

// Exit (probably an icon or button)
const Exit = styled("div")(() => ({
    "&:hover": {
        cursor: "pointer",
    },
}));

// TextField styling
const StyledTextField = styled(TextField)(() => ({
    minWidth: "400px",
    fontSize: "14px !important",
}));

// Container for a comment
const CommentContainer = styled("div")(() => ({
    padding: "20px 0 0",
    marginTop: "15px",
    marginBottom: "12px",
    borderTop: "1px solid #ededed",
}));

// Name and date (can reuse the same if needed)
const CommentName = styled("div")(() => ({
    fontSize: 12,
    paddingBottom: "20px",
}));

const CommentDate = styled("div")(() => ({
    fontSize: 12,
    paddingBottom: "20px",
}));

// The comment text
const CommentText = styled("div")(() => ({
    fontSize: 14,
    lineHeight: "20px",
}));

// Container styles to replace Grid
const FlexContainer = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    flexWrap: 'wrap',
    boxSizing: 'border-box'
}));

const FlexEnd = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
    width: '100%',
}));

const FlexStart = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'flex-start',
    width: '100%',
}));

const FullWidthDiv = styled('div')(() => ({
    width: '100%', overflowY: 'auto' 
}));

const DrawerStyle= styled(Drawer)(() => ({
    '& .MuiDrawer-paper': {
        padding: '0 20px',
        display: 'block',
        transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1)',
        maxWidth: '26rem',
        left: auto,
        right: 0
    },
}));

const Comments = (props) => {
    const {
        commentDraft,
        disabled,
        handleSubmitComment,
        handleClearComment,
        handleChange,
        toggleComments,
        comments,
        open,
        parentRecordType,
        parentRecordId,
        handleRequestUpdate,
        redirectTo,
        showRequestUpdateListing,
        showSubmitListing,
        setRequestUpdateAndSubmit,
        listing,
        userProfile,
    } = props;

    useEffect(() => {
        if (setRequestUpdateAndSubmit) setRequestUpdateAndSubmit(listing, userProfile);
    }, [listing]);

    const showRequestUpdateButton =
        showRequestUpdateListing !== undefined
            ? showRequestUpdateListing
            : parentRecordType === "property"
            ? true
            : false;

    const history = useHistory();

    const showSubmitButton = showSubmitListing !== undefined ? showSubmitListing : true;

    const requestUpdate = async () => {
        const result = await handleRequestUpdate(parentRecordType, parentRecordId);
        if (result.success) {
            if (parentRecordType.toLowerCase() === "listing") {
                history.push(redirectTo ? redirectTo : `/listing/${parentRecordId}`);
            } else if (parentRecordType.toLowerCase() === "property") {
                history.push(redirectTo ? redirectTo : `/property/${parentRecordId}`);
            }
        }
    };

    return (
        <DrawerStyle anchor="right" open={open} onClose={toggleComments} >
            <FlexContainer>
                <CommentHeader>
                    <h3>Comments ({comments.length})</h3>
                </CommentHeader>
                <div>
                    <Exit role="button" onClick={toggleComments}>
                        <RightChevron />
                    </Exit>
                </div>
                {showRequestUpdateButton || showSubmitButton ? (
                    <div style={{ fontSize: "14px" }}>
                        After typing your comment,{" "}
                        {showRequestUpdateButton && 'click "Request Update" to send to the Corporate Data Team'}
                        {showRequestUpdateButton && showSubmitButton && " or "}
                        {showSubmitButton && 'click "Submit" to add a standard comment'}.
                    </div>
                ) : (
                    ""
                )}
            </FlexContainer>
            <FullWidthDiv>
                <TextField
                    id="outlined-textarea"
                    placeholder="Write your comment here..."
                    multiline
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    onChange={handleChange}
                    value={commentDraft}
                    maxRows={25}
                />
            </FullWidthDiv>
            <FlexEnd>
                <div>
                    <Button onClick={handleClearComment} variant="outlined" color="primary">
                        Cancel
                    </Button>
                </div>
                {showRequestUpdateButton && (
                    <div>
                        <Button onClick={requestUpdate} variant="contained" color="secondary" disabled={disabled}>
                            Request Update
                        </Button>
                    </div>
                )}
                {showSubmitButton && (
                    <div>
                        <Button
                            onClick={(e) => handleSubmitComment(parentRecordType, parentRecordId)}
                            variant="contained"
                            color="primary"
                            disabled={disabled}
                        >
                            Submit
                        </Button>
                    </div>
                )}
            </FlexEnd>
            {comments.map((c, i) => (
                <CommentContainer key={`${parentRecordType}-comment-${i}`}>
                    <FlexContainer>
                        <div>
                            <CommentName>{c.auditCreatedBy}</CommentName>
                        </div>
                        <div>
                            <CommentDate>
                                posted on {moment(c.auditCreatedTimestamp).format("MM/DD/YY h:mm A")}
                            </CommentDate>
                        </div>
                    </FlexContainer>
                    <FlexStart>
                        <div>
                            <div key={`comment-${i}`}>{c.comment}</div>
                        </div>
                    </FlexStart>
                </CommentContainer>
            ))}
            <br />
            &nbsp;
        </DrawerStyle>
    );
};

export default Comments;